module.exports = __webpack_public_path__ + "static/media/40.261f0b41.jpg";